// extracted by mini-css-extract-plugin
module.exports = {"label":"label__2VVyc","danger":"danger__3dwK0","secondary":"secondary__171j7"};